import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Form/form';
import { css } from '@patternfly/react-styles';
export var Form = function Form(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isHorizontal = _a.isHorizontal,
      isHorizontal = _a$isHorizontal === void 0 ? false : _a$isHorizontal,
      props = __rest(_a, ["children", "className", "isHorizontal"]);

  return React.createElement("form", Object.assign({
    noValidate: true
  }, props, {
    className: css(styles.form, isHorizontal && styles.modifiers.horizontal, className)
  }), children);
};